import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {NgClass} from "@angular/common";
import {UserAvatarComponent} from "../user-avatar/user-avatar.component";

@Component({
  selector: "app-user-chip",
  templateUrl: "./user-chip.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, UserAvatarComponent],
})
export class UserChipComponent {
  @Input() label = "";
  @Input() picture?: string | null;
  @Input() avatarSize = 28;
  @Input() metaLabel?: string;
  @Input() removable = false;
  @Input() disabled = false;
  @Input() removeLabel = "Remove";
  @Input() containerClasses = "";
  @Output() requestRemove = new EventEmitter<void>();

  public onRemove(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.requestRemove.emit();
  }
}
